import React, { useEffect, useState, useRef } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Typography, AppBar, Tabs, Tab, Container } from "@material-ui/core";
import { Alerta } from "../components/Alerta";
import { Titulo } from "../components/Titulo";
import VistaPerfilEmpleado from "../components/gestionEmpleado/VistaPerfilEmpleado";
import EmpleadoFormDialog from "../components/gestionEmpleado/EmpleadoFormDialog";
import TareasEmpleado from "../components/gestionEmpleado/TareasEmpleado";
import FacturasEmpleado from "../components/gestionEmpleado/FacturasEmpleado";
import ComisionesEmpleado from "../components/gestionEmpleado/ComisionesEmpleado";
import Laboral from "../components/gestionEmpleado/gestionLaboral/Laboral";
import PlanesEmpleado from "src/components/gestionEmpleado/PlanesEmpleado";
import { useSelector } from "react-redux";
import { useHistorialVisita } from "src/hooks/useHistorialVisita";
import AtributosEmpleados from "src/components/gestionEmpleado/AtributosEmpleados";
import NotificacionesEmpleados from "src/components/gestionEmpleado/NotificacionesEmpleados";
import { useLazyGetEmpleadoQuery } from "src/services/empleadosApi";

export default function VerEmpleado() {
  const { id } = useParams();
  const [empleado, setEmpleado] = useState();
  const {
    empleado: user,
    sucursal: sucursalObtenida,
    rol,
  } = useSelector((state) => state.auth.user);
  const sucursal = sucursalObtenida.refSucursal;
  const [obtenerEmpleado] = useLazyGetEmpleadoQuery();
  const esSuperAdmin = rol === "SUPER_ADMIN";
  const mostrarTabsAdmin = ["SUPER_ADMIN", "ADMIN"].includes(rol);
  const puedeVerPerfilAjeno = ["SUPER_ADMIN", "ADMIN"].includes(rol);
  const esSelf = user?.rut === id;
  const debeRedirigirAPropio = !puedeVerPerfilAjeno && !esSelf;
  const [value, setValue] = useState(0);
  const [dialogEditOpen, setDialogEditOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [message, setMessage] = useState("");
  const isMounted = useRef(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useHistorialVisita(user);

  useEffect(() => {
    if (debeRedirigirAPropio) return;
    const cargarEmpleado = async () => {
      try {
        const empleadoActualizado = await obtenerEmpleado(id).unwrap();
        if (empleadoActualizado === -2) {
          window.location.reload();
          return;
        }
        if (isMounted.current) {
          setEmpleado(empleadoActualizado[0]);
        }
      } catch (error) {
        console.error("Error al obtener empleado:", error);
      }
    };
    cargarEmpleado();
  }, [id, debeRedirigirAPropio]);

  if (debeRedirigirAPropio) {
    return <Navigate to={`/dashboard/empleados/${user.rut}`} replace />;
  }

  return (
    <>
      {empleado?.rut !== undefined && (
        <>
          <Container>
            <Titulo>
              <Typography
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  paddingRight: "1rem",
                  paddingLeft: "1rem",
                }}
                variant="h5"
              >
                Empleado: {empleado.nombre} {empleado.apellidos}
              </Typography>
            </Titulo>
            <div>
              <AppBar position="static" color="default">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="Datos" />
                  {mostrarTabsAdmin && <Tab label="Atributos" />}
                  {mostrarTabsAdmin && <Tab label="Tareas" />}
                  {mostrarTabsAdmin && <Tab label="Planes" />}
                  {mostrarTabsAdmin && <Tab label="Facturas" />}
                  {mostrarTabsAdmin && <Tab label="Comisiones" />}
                  {mostrarTabsAdmin && <Tab label="Laboral" />}
                  {esSuperAdmin && <Tab label="Notificaciones" />}
                </Tabs>
              </AppBar>
            </div>

            {value === 0 && (
              <VistaPerfilEmpleado
                empleado={empleado}
                esVisible={value === 0}
                puedeEditar={
                  ["SUPER_ADMIN", "ADMIN"].includes(rol) ||
                  empleado?.rut === user.rut
                }
                onEdit={() => setDialogEditOpen(true)}
              />
            )}

            {dialogEditOpen && (
              <EmpleadoFormDialog
                open={dialogEditOpen}
                onClose={async () => {
                  setDialogEditOpen(false);
                  try {
                    const empleadoActualizado =
                      await obtenerEmpleado(id).unwrap();
                    if (empleadoActualizado === -2) {
                      window.location.reload();
                      return;
                    }
                    if (isMounted.current) {
                      setEmpleado(empleadoActualizado[0]);
                    }
                  } catch (error) {
                    console.error("Error al obtener empleado:", error);
                  }
                }}
                mode="edit"
                defaultValues={empleado}
              />
            )}

            {mostrarTabsAdmin && (
              <>
                <AtributosEmpleados value={value} empleado={empleado} />

                <TareasEmpleado
                  value={value}
                  esSuperAdmin
                  empleado={empleado}
                  setEmpleado={setEmpleado}
                />

                <PlanesEmpleado
                  value={value}
                  empleado={empleado}
                  setShowErrorMessage={setShowErrorMessage}
                  setMessage={setMessage}
                />

                <FacturasEmpleado
                  value={value}
                  empleado={empleado}
                  setShowErrorMessage={setShowErrorMessage}
                  setMessage={setMessage}
                />

                <ComisionesEmpleado value={value} empleado={empleado} />

                <Laboral
                  value={value}
                  empleado={empleado}
                  vista="SUPER_ADMIN"
                />
              </>
            )}

            {esSuperAdmin && (
              <NotificacionesEmpleados
                value={value}
                empleado={empleado}
                tabIndex={7}
              />
            )}

            {showAlert && (
              <Alerta
                showAlert={showAlert}
                setShowAlert={setShowAlert}
                color="success"
                message="Datos del Empleado guardados"
              />
            )}

            {showErrorMessage && (
              <Alerta
                showAlert={showErrorMessage}
                setShowAlert={setShowErrorMessage}
                setShowErrorMessage={setShowErrorMessage}
                color="error"
                message={message}
              />
            )}
          </Container>
        </>
      )}
    </>
  );
}
